
<template>
  <div id='waterLevel'>
    <svg id='svgWaterLevel' height='460px'>
    </svg>
  </div>
</template>
<script>
/* globals window, requestAnimationFrame */
import * as d3 from 'd3'
import {db, fbPaths} from '../../firebase/firebase'
import {svgResizer} from '../mixins/svgResizer'
export default {
  name: 'vue-water-depth',
  mixins: [svgResizer],
  data () {
    return {
      clientWidth: 45,
      clientHeight: 460,
      markerDimensions: {
        triangleWidth: 10,
        lineWidth: 15,
        height: 10
      },
      selectWell: '',
      wells: {}
      // depth: [
      //   {'meters': 200}
      // ]
    }
  },
  firebase: {
    wells: {
      source: db.ref(fbPaths.wellDepth),
      asObject: true
    }
  },
  computed: {
    depth () {
      return [this.wells[this.selectedWell]]
    },
    depthTriangle () {
      return (this.markerDimensions.triangleWidth) + ',' + (-this.markerDimensions.height) +
      ' 0' + ',' + (-this.markerDimensions.height) +
      ' ' + (this.markerDimensions.triangleWidth / 2) + ',0 '
    },
    depthLine () {
      return d3.line().x()
    },
    selectedWell () {
      return this.$route.query['wellkey']
    }
  },
  watch: {
    depth: function () {
      d3.select('#svgWaterLevel')
      .select('#depth-marker-triangle')
      .transition()
      .duration(750)
      this.breakDownVisualization()
      this.setUpVisualization()
    }
  },
  methods: {
    getScales () {
      const x = d3.scaleLinear()
                  .domain([-10, 10])
                  .range([5, this.clientWidth])
      const y = d3.scaleLinear()
                   .domain([0, 200])
                   .range([10, this.clientHeight - 10])
      return { x, y }
    },
    breakDownVisualization () {
      d3.select('#depth-marker-line').remove()
      d3.select('#depth-marker-triangle').remove()
      d3.select('#yaxis').remove()
    },
    setUpVisualization () {
      const scale = this.getScales()
      var marker = d3.select('#svgWaterLevel')
        .attr('width', this.clientWidth)

      marker.append('polygon')
        .data(this.depth)
        .attr('id', 'depth-marker-triangle')
        .attr('points', this.depthTriangle)
        .attr('class', 'data-line')
        .attr('stroke-width', 2)
        .attr('fill', 'none')
        .attr('transform', function (d) {
          return 'translate(2, ' + scale.y(d.meters) + ')'
        })
        .append('svg:title')
        .text(function (d) { return d.meters })

      marker.append('line')
        .data(this.depth)
        .attr('x1', 0)
        .attr('x2', this.markerDimensions.lineWidth)
        .attr('class', 'data-line')
        .attr('id', 'depth-marker-line')
        .attr('y1', 0)
        .attr('y2', 0)
        .attr('stroke-width', 2)
        .attr('transform', function (d) {
          return 'translate(0, ' + scale.y(d.meters) + ')'
        })

      let yAxis = d3.axisRight().scale(scale.y)
      d3.select('#svgWaterLevel')
        .append('g')
        .attr('transform', 'translate(' + (this.markerDimensions.triangleWidth + 5) + ', 0)')
        .attr('id', 'yaxis')
        .attr('class', 'axis')
        .call(yAxis)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visualization/WaterLevel.vue